'use client';

import dynamic from 'next/dynamic';
import React, { Fragment } from 'react';
import { LanguageSync } from '@/components/helpers/LanguageSync';
import { ThemeSync } from '@/components/helpers/ThemeSync';

const AuthGuard = dynamic(() => import('@/modules/auth/components/AuthGuard').then((mod) => mod.AuthGuard), {
  ssr: false,
});

const GlobalSocketListener = dynamic(
  () => import('@/components/helpers/GlobalSocketListener').then((mod) => mod.GlobalSocketListener),
  { ssr: false },
);

const ClientBootstrap = dynamic(
  () => import('@/components/helpers/ClientBootstrap/ClientBootstrap').then((mod) => mod.ClientBootstrap),
  { ssr: false },
);

const ProfileModalRenderer = dynamic(
  () =>
    import('@/modules/profile/components/ProfileModal/ProfileModalRenderer').then((mod) => mod.ProfileModalRenderer),
  { ssr: false },
);

export const RootClientLogic = () => {
  return (
    <Fragment>
      <AuthGuard />
      <GlobalSocketListener />
      <ClientBootstrap />
      <LanguageSync />
      <ThemeSync />
      <ProfileModalRenderer />
    </Fragment>
  );
};
